import type { ChatQuestionPeriod, GetChatConversationsQueryParams } from '@massilia/contracts'

export const chatKeys = {
  all: ['chat'] as const,
  conversation: (sessionId: string) => ['chat', 'conversations', 'detail', sessionId] as const,
  conversations: (params: GetChatConversationsQueryParams) =>
    ['chat', 'conversations', 'list', params] as const,
  questionCategories: (period: ChatQuestionPeriod) =>
    ['chat', 'conversations', 'categories', period] as const,
  stream: ['chat', 'stream'] as const,
}
